'use strict';

var MobileDetect = require('mobile-detect');

// @ngInject
module.exports = function ($window,
                           $timeout) {
    this.mobileDetect = new MobileDetect($window.navigator.userAgent);

    $timeout(function () {
        /* jshint ignore:start */
        function afterReveal(el) {
            el.addEventListener('animationend', function (event) {
                $('.wow').each(function () {
                    $(this).css('opacity', 1);
                });
            });
        }

        new WOW({callback: afterReveal}).init();
        /* jshint ignore:end */
    });
};
